import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react';
import React from 'react';

import { IconClose } from '@/assets';
import { Buttons } from '@/components';

import useDeleteCollection from './useDeleteCollection';

const DeleteCollection: React.FC<{
  isOpen: boolean;
  onOpenChange: () => void;
  collectionId: number;
}> = ({ isOpen, onOpenChange, collectionId }) => {
  const { loading, handleDeleteCollection } = useDeleteCollection();

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      hideCloseButton
      scrollBehavior="inside"
      placement="center"
    >
      <ModalContent className="min-w-[400px] rounded-[32px]">
        {(onClose) => (
          <>
            <ModalHeader className="flex items-center justify-between p-10 pb-8">
              <span className="text-[24px] font-[600]">Delete collection</span>
              <div
                onClick={onClose}
                className="flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-[8px] bg-gray-100"
              >
                <IconClose />
              </div>
            </ModalHeader>
            <ModalBody className="max-h-[350px] px-[40px]">
              <div className="text-[16px] leading-[1.5] text-gray-500">
                Are you sure you want to delete this collection? The artworks won’t be affected
              </div>
            </ModalBody>
            <ModalFooter className="mt-5 block p-0">
              <div className="flex items-center justify-end px-[40px] py-[30px]">
                <Buttons onClick={onClose} typeBtn="cancel">
                  Cancel
                </Buttons>
                <Buttons
                  isLoading={loading}
                  onClick={() => handleDeleteCollection(collectionId)}
                  className="ml-3"
                >
                  Confirm
                </Buttons>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default DeleteCollection;
